import { lazy, Suspense } from 'react';
import type { RouteObject } from 'react-router-dom';
import NotFound from '@/pages/NotFound';
import Home from '@/pages/home/page';

const About = lazy(() => import('@/pages/about/page'));
const Services = lazy(() => import('@/pages/services/page'));
const KitchenRemodeling = lazy(() => import('@/pages/services/kitchen-remodeling/page'));
const BathroomRemodeling = lazy(() => import('@/pages/services/bathroom-remodeling/page'));
const Plumbing = lazy(() => import('@/pages/services/plumbing/page'));
const GeneralContracting = lazy(() => import('@/pages/services/general-contracting/page'));
const Projects = lazy(() => import('@/pages/projects/page'));
const Reviews = lazy(() => import('@/pages/reviews/page'));
const Contact = lazy(() => import('@/pages/contact/page'));
const ServiceDetail = lazy(() => import('@/pages/services/detail/page'));
const CleaningServices = lazy(() => import('@/pages/cleaning-services/page'));
const CleaningServiceDetail = lazy(() => import('@/pages/cleaning-services/detail/page'));

const withSuspense = (Component: React.ComponentType) => (
  <Suspense fallback={<div className="min-h-screen" />}>
    <Component />
  </Suspense>
);

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/about',
    element: withSuspense(About),
  },
  {
    path: '/services',
    element: withSuspense(Services),
  },
  {
    path: '/services/kitchen-remodeling',
    element: withSuspense(KitchenRemodeling),
  },
  {
    path: '/services/bathroom-remodeling',
    element: withSuspense(BathroomRemodeling),
  },
  {
    path: '/services/plumbing',
    element: withSuspense(Plumbing),
  },
  {
    path: '/services/general-contracting',
    element: withSuspense(GeneralContracting),
  },
  {
    path: '/services/:slug',
    element: withSuspense(ServiceDetail),
  },
  {
    path: '/cleaning-services',
    element: withSuspense(CleaningServices),
  },
  {
    path: '/cleaning-services/:slug',
    element: withSuspense(CleaningServiceDetail),
  },
  {
    path: '/projects',
    element: withSuspense(Projects),
  },
  {
    path: '/reviews',
    element: withSuspense(Reviews),
  },
  {
    path: '/contact',
    element: withSuspense(Contact),
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;